/*
  index.js

  Entry point for the React standalone app.
*/

// Npm.
import React, { useMemo } from 'react';
import ReactDOM from 'react-dom';

// Botech context.
import botech from './react-app-botech-context';

// Components.
import RootApp from './editor';

/**
 * Outer wrapper to set the botech context,
 * specific for the standalone react-app version.
 */
function RootAppWrapper() {

  // TODO: If the app ever uses the history API, these need to be monitored for changes.
  const searchParams = new URLSearchParams(window.location.search);
  const userId = searchParams.get('userId');
  const modelId = searchParams.get('modelId');
  const readOnly = searchParams.get('readOnly') === '1';

  const value = useMemo(() => {
    return {
      ...botech,
      userId: userId || 'default',
      modelId: modelId || null,
      readOnly,
    };
  }, [userId, modelId, readOnly]);

  return (
    <RootApp botech={value} />
  );
}

// Render the root app.
// NOTE: Strict mode runs useEffects twice:
// https://www.techiediaries.com/react-18-useeffect/
ReactDOM.render(
  <React.StrictMode>
    <RootAppWrapper />
  </React.StrictMode>,
  document.getElementById('root')
);
